import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>Transform to a Winning Search Visibility</h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p>
              Our search engine marketing agency optimizes your digital reach by
              targeting high-intent keywords, driving precise traffic, and
              maximizing conversions. Effective SEM ensures your business
              captures valuable search visibility and achieves measurable
              growth.
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Dominate High-Value Keywords</h6>
                <p>
                  Secure top positions on high-conversion keywords that your
                  competitors struggle to rank for. Capture the majority of
                  search-driven revenue in your niche.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Hyper-Targeted Ad Delivery</h6>
                <p>
                  Understand customer personas and deliver personalized ads to
                  users most likely to convert, reducing cost-per-acquisition
                  and maximizing ad relevance.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Accelerated Sales Pipeline</h6>
                <p>
                  Drive high-intent leads directly into your sales funnel with
                  strategic bidding on long-tail keywords. Cut short the sales
                  cycle and increase close rates.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>ROI-Driven Budget Allocation</h6>
                <p>
                  Dynamically adjust ad spending based on campaign performance
                  insights, ensuring that every dollar is allocated to the most
                  profitable channels and tactics.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Scale Retargeting Higher Conversions</h6>
                <p>
                  Expand retargeting efforts with segmented campaigns. Be it
                  cart abandonment or content engagement, ensure you stay
                  top-of-mind and drive conversions.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Long-Term Customer Acquisition</h6>
                <p>
                  Integrate SEM with retargeting and CRM data to nurture
                  prospects over time, turning one-time visitors into loyal,
                  repeat customers with higher lifetime value.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
